"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const megamenu_1 = require("@/Redux/Actions/megamenu");
const Typography_1 = require("../Typography");
const style = __importStar(require("./styled"));
const spa_core_1 = require("@episerver/spa-core");
const LinkList = ({ links, rowGap }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const cmsState = (0, spa_core_1.useCmsState)();
    const isForceReloadLink = `${!(cmsState === null || cmsState === void 0 ? void 0 : cmsState.iContent)}`;
    return (react_1.default.createElement(style.LinkList, { rowGap: rowGap }, links === null || links === void 0 ? void 0 : links.map((link, i) => (react_1.default.createElement(style.LinkText, { key: i, type: Typography_1.Types.BODY_1 },
        react_1.default.createElement(style.Link, { href: link.uri, onClick: () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)), "data-force-reload": isForceReloadLink }, link.title))))));
};
exports.default = LinkList;
